module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', [_vm._v("Primary")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1), _vm._v(" "), _c('h3', [_vm._v("Secondary")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    }
  }, [_vm._v("Secondary")])], 1), _vm._v(" "), _c('h3', [_vm._v("Default")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "default"
    }
  }, [_vm._v("Default")])], 1), _vm._v(" "), _c('h3', [_vm._v("Subtle")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    attrs: {
      "type": "subtle",
      "size": "small"
    }
  }, [_vm._v("Subtle")])], 1), _vm._v(" "), _c('h3', [_vm._v("Icon in button")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "icon": "settings"
    }
  }, [_vm._v("Icon in button")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "icon": "settings"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Disabled")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    }
  }, [_vm._v("Secondary")])], 1), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "default",
      "size": "small"
    }
  }, [_vm._v("Default")])], 1), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Subtle")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "subtle",
      "size": "small"
    }
  }, [_vm._v("Subtle")])], 1), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Icon in button")]), _vm._v(" "), _c('div', [_c('mt-button', {
    attrs: {
      "icon": "settings",
      "size": "small"
    }
  }, [_vm._v("Icon in button")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "icon": "settings"
    }
  })], 1)]), _vm._v(" "), _vm._m(5, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('div', [_c('mt-button', {
    attrs: {
      "size": "small",
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1)]), _vm._v(" "), _vm._m(6, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizeDefault,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(7, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizingSmall,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(8, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizingSmallinButton,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(9, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h2', [_vm._v("States")]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesPrimary,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(10, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesSecondary,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(11, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesDefault,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(12, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesSubtle,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(13, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesIconInButton,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(14, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Buttons")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Background: #055AFE")]), _vm._v(" "), _c('p', [_vm._v("Text: #FFFFFF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Border: #055AFE")]), _vm._v(" "), _c('p', [_vm._v("Text: #055AFE")]), _vm._v(" "), _c('p', [_vm._v("border: #718091")]), _vm._v(" "), _c('p', [_vm._v("Text: #718091")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Background: #EDEFF3")]), _vm._v(" "), _c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Text: #485464")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Text: #485464")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Background: #EDEFF3")]), _vm._v(" "), _c('p', [_vm._v("Text: #B2C0D0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Corner radius: 4px")]), _vm._v(" "), _c('p', [_vm._v("Height: 48px")]), _vm._v(" "), _c('p', [_vm._v("Horizontal padding: 16px")]), _vm._v(" "), _c('p', [_vm._v("Minimum width: 150px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 16px")]), _vm._v(" "), _c('p', [_vm._v("Line height: 24px ")]), _vm._v(" "), _c('p', [_vm._v("border: 2px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Corner radius: 2px")]), _vm._v(" "), _c('p', [_vm._v("Height: 36px")]), _vm._v(" "), _c('p', [_vm._v("Horizontal padding: 12px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 14px ")]), _vm._v(" "), _c('p', [_vm._v("Line height: 22px ")]), _vm._v(" "), _c('p', [_vm._v("border: 1px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Corner radius: 2px")]), _vm._v(" "), _c('p', [_vm._v("Height: 36px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 14px ")]), _vm._v(" "), _c('p', [_vm._v("Line height: 22px ")]), _vm._v(" "), _c('p', [_vm._v("border: 1px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Default background: #097DB7   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Hover background: #0D72A9   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Active background: #106391   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Disabled background: #EDEFF3  Text: #485464  opacity 30%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Default border: #097DB7   text: #097DB7")]), _vm._v(" "), _c('p', [_vm._v("Hover background: #0D72A9   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Active background: #106391   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Disabled background: #EDEFF3   Text: #485464  opacity 30%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Default border: #718091   text: #718091")]), _vm._v(" "), _c('p', [_vm._v("Hover border: #0D72A9   text: #0D72A9")]), _vm._v(" "), _c('p', [_vm._v("Active background: #106391   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Disabled background: #EDEFF3   Text: #485464  opacity 30%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Default background: #EDEFF3   border: #B2C0D0   text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Hover background: #0D72A9   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Active background: #106391   text: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Disabled background: #EDEFF3    Text: #485464  opacity 30%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Default text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Hover text: #0D72A9")]), _vm._v(" "), _c('p', [_vm._v("Active text: #106391")]), _vm._v(" "), _c('p', [_vm._v("Disabled Text: #485464  opacity 30%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("Default background: #EDEFF3   border: #B2C0D0   text: #485464   icon: #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Hover background: #0D72A9   text: #FFFFFF   icon: #FFFFFF   ")]), _vm._v(" "), _c('p', [_vm._v("Active background: #106391   text: #FFFFFF   icon: #FFFFFF")]), _vm._v(" "), _c('p', [_vm._v("Disabled background: #EDEFF3   Text: #485464  opacity 30%   icon: #485464  opacity 30%")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010769e9","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buttons.vue
// module id = 75h5
// module chunks = 0